export default {

    value: 'Value',
    name_ar: 'Name Ar',
    name_en: 'Name En',
};
